// src/reducers/registrationSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface HealthInfo {
  Height?: number;
  Weight?: number;
  BloodType?: string;
}

interface LocationInfo {
  Latitude?: number;
  Longitude?: number;
  AreaId?: number;
  CityId?: number;
  Address?: string;
}

interface UserDetails {
  Id: number;
  CountryId?: number;
  PhoneNumber: string;
  username?: string;
  FullName: string;
  FullNameEn: string | null;
  FullNameAr: string | null;
  confirmPassword?: string;
  Gender: string | null;
  Birthday?: Date | null;
  Image?: any;
  CompletePercentage: number;
  HealthInfoPercentage: number;
  AddressInfoPercentage: number;
  ProfileImage: string;
  HealthInfo?: HealthInfo;
  LocationInfo?: LocationInfo;
  AccountTypeId: string;
  specialtyFile?: File | File[] | null;
  SpecialtyId?: string | number | null;
  SubSpecialtyId?: string | number | null;
  Country?:any
}

interface RegistrationState {
  step: number;
  userDetails: UserDetails;
  newPhoneNumber: string;
  ChangePhoneNumberId: number;
}

const initialState: RegistrationState = {
  step: 1,
  userDetails: {
    Id: -1,
    CountryId: 1,
    PhoneNumber: "",
    username: "",
    FullName: "",
    FullNameEn: "",
    FullNameAr: "",
    confirmPassword: "",
    Gender: "",
    Birthday: null,
    Image: null,
    CompletePercentage: 0,
    HealthInfoPercentage: 0,
    AddressInfoPercentage: 0,
    ProfileImage: "",
    HealthInfo: {},
    LocationInfo: {},
    AccountTypeId: "",
    specialtyFile: null,
    SpecialtyId: "",
    SubSpecialtyId: "",
  },
  newPhoneNumber: "",
  ChangePhoneNumberId: -1, // Initialized as null
};

const registrationSlice = createSlice({
  name: "registration",
  initialState,
  reducers: {
    nextStep: (state) => {
      state.step += 1;
    },
    prevStep: (state) => {
      state.step -= 1;
    },
    setUserDetails: (state, action: PayloadAction<Partial<UserDetails>>) => {
      state.userDetails = { ...state.userDetails, ...action.payload };
    },
    resetUserDetails: (state) => {
      state.userDetails = initialState.userDetails;
    },
    setNewPhoneNumber: (state, action: PayloadAction<string>) => {
      state.newPhoneNumber = action.payload;
    },
    setChangePhoneNumberId: (state, action: PayloadAction<number>) => {
      state.ChangePhoneNumberId = action.payload;
    },
    updateUserDetailsPhoneNumber: (state, action: PayloadAction<string>) => {
      state.userDetails.PhoneNumber = action.payload;
      state.newPhoneNumber = "";
    },
    setCompletionPercentages: (
      state,
      action: PayloadAction<{
        CompletePercentage: number;
        HealthInfoPercentage: number;
        AddressInfoPercentage: number;
      }>,
    ) => {
      const {
        CompletePercentage,
        HealthInfoPercentage,
        AddressInfoPercentage,
      } = action.payload;
      state.userDetails.CompletePercentage = CompletePercentage;
      state.userDetails.HealthInfoPercentage = HealthInfoPercentage;
      state.userDetails.AddressInfoPercentage = AddressInfoPercentage;
    },
    // New actions for updating health and location info
    setHealthInfo: (state, action: PayloadAction<HealthInfo>) => {
      state.userDetails.HealthInfo = action.payload;
    },
    setLocationInfo: (state, action: PayloadAction<LocationInfo>) => {
      state.userDetails.LocationInfo = action.payload;
    },
  },
});

export const {
  nextStep,
  prevStep,
  setUserDetails,
  resetUserDetails,
  setNewPhoneNumber,
  setChangePhoneNumberId,
  updateUserDetailsPhoneNumber,
  setCompletionPercentages,
  setHealthInfo, // Export the new action
  setLocationInfo, // Export the new action
} = registrationSlice.actions;

export default registrationSlice.reducer;
